import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiDialog = {
  styleOverrides: {
    paper: {
      borderRadius: "7px",
      Width: "550px",
    },
  },
} satisfies Components<Theme>["MuiDialog"];

export const MuiDialogActions = {
  styleOverrides: {
    root: {
      marginTop: "8px",
      paddingTop: "8px",
      paddingLeft: "36px !important",
      paddingRight: "36px !important",
      marginBottom: "8px",
    },
  },
} satisfies Components<Theme>["MuiDialogActions"];

export const MuiDialogTitle = {
  styleOverrides: {
    root: {
      marginTop: "8px",
      paddingLeft: "36px",
      paddingRight: "36px",
      paddingBottom: "16px",
      marginBottom: "8px",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
  },
} satisfies Components<Theme>["MuiDialogTitle"];

export const MuiDialogContent = {
  styleOverrides: {
    root: {
      marginTop: "16px",
      paddingLeft: "36px",
      paddingRight: "36px",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
  },
} satisfies Components<Theme>["MuiDialogContent"];
